export default {
  init() {
    // JavaScript to be fired on the about us page
    $('.thumbs > div:first-of-type()').on('mouseenter', () => {
      $('.shirt').hide();
      $('.shirts > div:first-of-type()').show();
    });
    $('.thumbs > div:nth-of-type(2)').on('mouseenter', () => {
      $('.shirt').hide();
      $('.shirts > div:nth-of-type(2)').show();
    });
  },
};
